import { formatDisplayDate } from '@helpers';

export const createReplacementForm = () => ({
  dates: null,
  substrate: {
    name: null,
    width: null,
    height: null,
  },
  replacement: {
    name: null,
    width: null,
    height: null,
  },
});

export const fillReplacementFormFromData = (data) => {
  const r = createReplacementForm();

  r.dates = [
    data.from ? formatDisplayDate(data.from, { dateFormat: 'yyyy-MM-dd' }) : '',
    data.to ? formatDisplayDate(data.to, { dateFormat: 'yyyy-MM-dd' }) : '',
  ];

  r.substrate.name = data.substrate.name || null;
  r.substrate.width = typeof data.substrate.width === 'number' ? data.substrate.width : null;
  r.substrate.height = typeof data.substrate.height === 'number' ? data.substrate.height : null;

  r.replacement.name = data.replacement.name || null;
  r.replacement.width = typeof data.replacement.width === 'number' ? data.replacement.width : null;
  r.replacement.height = typeof data.replacement.height === 'number' ? data.replacement.height : null;

  return r;
};

export const prepareReplacementData = (data) => {
  const r = createReplacementForm();
  delete r.dates;

  r.from = (data.dates && data.dates[0]) ? `${data.dates[0]}T00:00:00.000Z` : null;
  r.to = (data.dates && data.dates[1]) ? `${data.dates[1]}T23:59:59.000Z` : null;

  r.substrate.name = data.substrate.name || null;
  r.substrate.width = typeof data.substrate.width === 'number' ? data.substrate.width : null;
  r.substrate.height = typeof data.substrate.height === 'number' ? data.substrate.height : null;

  r.replacement.name = data.replacement.name || null;
  r.replacement.width = typeof data.replacement.width === 'number' ? data.replacement.width : null;
  r.replacement.height = typeof data.replacement.height === 'number' ? data.replacement.height : null;

  return r;
};
